	<!-- TemplateBeginEditable name="hero" -->
	<div class="dcf-hero dcf-hero-default">
		<!-- TemplateEndEditable -->
		<div class="dcf-hero-group-1">
			<div class="dcf-breadcrumbs-wrapper">
				<nav class="dcf-breadcrumbs" id="dcf-breadcrumbs" role="navigation" aria-label="breadcrumbs">
					<!-- TemplateBeginEditable name="breadcrumbs" -->
					<ol>
						<li><a href="https://www.unl.edu/">Nebraska</a></li>
						<li><a href="/">TCAN / VITA Lincoln</a></li>
						<li><a href="/volunteer">Staff</a></li>
						<li><span aria-current="page">Login</span></li>
					</ol>
					<!-- TemplateEndEditable -->
				</nav>
			</div>
			<header class="dcf-page-title" id="dcf-page-title">
				<!-- TemplateBeginEditable name="pagetitle" -->
				<h1>Staff Login</h1>
				<!-- TemplateEndEditable -->
			</header>
			<!-- TemplateBeginEditable name="herogroup1" -->
			<!-- TemplateEndEditable -->
		</div>
		<!-- TemplateBeginEditable name="herogroup2" -->
		<div class="dcf-hero-group-2">
		</div>
		<!-- TemplateEndEditable -->
	</div>
	<div class="dcf-main-content dcf-wrapper">
		<!-- TemplateBeginEditable name="maincontentarea" -->
		<div class="dcf-bleed">
			<div id="login_panel" class="dcf-grid dcf-wrapper dcf-pb-10" [hidden]="!showLoginForm">
				<div class="dcf-col-100% dcf-1st dcf-col-50%-end@md dcf-2nd@md dcf-pb-5">
					<form id="login_form" (ngSubmit)="onFormSubmission()">
						<fieldset>
              <div [hidden]="error === null" class="error"> 
                {{ error }} 
              </div>
							<legend>User Login</legend>
							<section class="dcf-form-group">
								<label class="dcf-label" for="login_email">E-mail Address</label>
								<input name="loginEmail" id="login_email" class="dcf-text-input form-control" placeholder="john@email.com" type="text" autocomplete="username" [(ngModel)]="loginEmail"/>
							</section>
							<section class="dcf-form-group dcf-mt-1">
								<label class="dcf-label" for="login_password">Password</label>
								<input name="loginPassword" id="login_password" class="dcf-text-input form-control" placeholder="Password" type="password" autocomplete="current-password"  [(ngModel)]="loginPassword"/>
							</section>
						</fieldset>
						<input class="dcf-btn dcf-btn-primary dcf-mt-5" type="submit" value="Login" />
					</form>
				</div>
				<div class="dcf-col-100% dcf-2nd dcf-col-50%-start@md dcf-1st@md">
					<p>
						<a href="/volunteer">Information about volunteering</a>
					</p>
					<p>
						<a id="login_register_link" href="/login#" (click)="toggleForm()" class="toggle_form" tabindex="-1">
							Forgot Password/Register
						</a>
					</p>
				</div>
			</div>
			<div id="register_panel" class="dcf-grid dcf-wrapper dcf-pb-10" [hidden]="!showRegisterPannel">
				<div class="dcf-col-100% dcf-1st dcf-col-50%-end@md dcf-2nd@md dcf-pb-5">
					<form id="register_form" accept-charset="UTF-8" role="form">
						<fieldset>
							<legend>Reset Password/Register</legend>
							<p id="register_info">
								Please provide the e-mail address associated with your account. Once the form is submitted, you will receive an e-mail with further instructions.
							</p>
							<section class="dcf-form-group dcf-mt-1">
								<label class="dcf-label" for="register_email">E-mail address</label>
								<input id="register_email" name="register_email" class="dcf-text-input form-control" placeholder="john@email.com" [(ngModel)]="registrationEmail" type="text" autocomplete="new-password" />
							</section>
						</fieldset>
						<input class="dcf-btn dcf-btn-primary dcf-mt-5" id="register_submit" type="submit" (click)="registerEmail()" value="Reset here? Password/Register" />
					</form>
					<p id="register_success" [hidden]="!showLoginForm">
						<span style="font-weight:bold; color:#288700;">
							Your request was received successfully. Please check your email for further instructions.
						</span>
					</p>
				</div>
				<div class="dcf-col-100% dcf-2nd dcf-col-50%-start@md dcf-1st@md">
					<p>
						<a id="register_back_link" href="/login#" (click)="toggleForm()" class="toggle_form">
							<span class="wdn-icon-angle-double-left" aria-hidden="true"></span><span class="dcf-sr-only">double left arrow icon</span>
							Back To Login Form
						</a>
					</p>
				</div>
			</div>
		</div>
		<!-- TemplateEndEditable -->
	</div>